(() => {
  const PACK_OPTION_POSITION = 3;
  const SIZE_OPTION_POSITION = 1;
  const COLOUR_OPTION_INDEX = 1;
  const processedProducts = new Set();
  
  function isMobileVariantPicker() {
  return window.matchMedia("(max-width: 699px)").matches;
}

  function getProductForm(picker) {
    const formId = picker?.getAttribute("form-id");

    if (!formId) {
      return null;
    }

    return document.forms[formId] || document.getElementById(formId);
  }

  function getPickerFromInput(input) {
    const formId = input.getAttribute("form");

    if (!formId) {
      return null;
    }

    return document.querySelector(
      `variant-picker[form-id="${CSS.escape(formId)}"]`
    );
  }

  function readVariantData(picker) {
    const script = picker.querySelector(
      "script[data-smart-variant-data]"
    );

    if (!script) {
      return null;
    }

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.error(
        "Paragon Smart Variants could not read variant data.",
        error
      );

      return null;
    }
  }

  function getOptionInputs(picker) {
    const form = getProductForm(picker);

    if (!form) {
      return [];
    }

    return Array.from(form.elements).filter((element) =>
      element.matches("input[data-option-position]")
    );
  }

  function getSelectedOptionValueIds(picker) {
    return getOptionInputs(picker)
      .filter((input) => input.checked)
      .sort(
        (a, b) =>
          Number(a.dataset.optionPosition) -
          Number(b.dataset.optionPosition)
      )
      .map((input) => String(input.value));
  }

  function isExactAvailableVariant(variant, selectedValues) {
    return (
      variant.available &&
      variant.optionValueIds.length === selectedValues.length &&
      variant.optionValueIds.every(
        (value, index) =>
          String(value) === String(selectedValues[index])
      )
    );
  }

  function scoreVariant(variant, selectedValues) {
    return variant.optionValueIds.reduce(
      (score, value, index) => {
        if (
          String(value) !==
          String(selectedValues[index])
        ) {
          return score;
        }

        return (
          score +
          (selectedValues.length - index) * 100
        );
      },
      0
    );
  }

  function findBestAvailableVariant(
    variants,
    selectedValues,
    changedIndex
  ) {
    const availableVariants = variants.filter(
      (variant) => variant.available
    );

    if (!availableVariants.length) {
      return null;
    }

    for (
      let preserveCount = changedIndex + 1;
      preserveCount >= 1;
      preserveCount -= 1
    ) {
      const candidates = availableVariants.filter(
        (variant) => {
          for (
            let index = 0;
            index < preserveCount;
            index += 1
          ) {
            if (
              String(variant.optionValueIds[index]) !==
              String(selectedValues[index])
            ) {
              return false;
            }
          }

          return true;
        }
      );

      if (candidates.length) {
        candidates.sort(
          (a, b) =>
            scoreVariant(b, selectedValues) -
            scoreVariant(a, selectedValues)
        );

        return candidates[0];
      }
    }

    return availableVariants[0];
  }

  function markVariantAsSelected(
    picker,
    optionValueIds
  ) {
    const inputs = getOptionInputs(picker);

    optionValueIds.forEach((optionValueId, index) => {
      const position = index + 1;

      const matchingInput = inputs.find(
        (input) =>
          Number(input.dataset.optionPosition) ===
            position &&
          String(input.value) ===
            String(optionValueId)
      );

      if (matchingInput) {
        matchingInput.checked = true;
      }
    });
  }

  async function handleVariantChange(event) {
  /* On mobile, let Impact handle variant selection normally. */
  if (isMobileVariantPicker()) {
    return;
  }

  const input = event.target;

    if (
      !(input instanceof HTMLInputElement) ||
      !input.matches("input[data-option-position]") ||
      !input.name.includes("option")
    ) {
      return;
    }

    const picker = getPickerFromInput(input);

    if (
      !picker ||
      typeof picker.selectCombination !== "function"
    ) {
      return;
    }

    const data = readVariantData(picker);

    if (!data?.variants?.length) {
      return;
    }

    const selectedValues =
      getSelectedOptionValueIds(picker);

    if (!selectedValues.length) {
      return;
    }

    const exactVariant = data.variants.find(
      (variant) =>
        isExactAvailableVariant(
          variant,
          selectedValues
        )
    );

    if (exactVariant) {
      return;
    }

    const changedIndex =
      Number(input.dataset.optionPosition) - 1;

    const bestVariant = findBestAvailableVariant(
      data.variants,
      selectedValues,
      changedIndex
    );

    if (!bestVariant) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    markVariantAsSelected(
      picker,
      bestVariant.optionValueIds
    );

    try {
      await picker.selectCombination({
        optionValues:
          bestVariant.optionValueIds.map(String),
        productChange:
          input.hasAttribute("data-product-url")
      });
    } catch (error) {
      console.error(
        "Paragon Smart Variants could not select a valid variant.",
        error
      );
    }
  }

  function filterPackSizes(root = document) {
    const packInputs = root.querySelectorAll?.(
      `input[data-option-position="${PACK_OPTION_POSITION}"]`
    );

    if (!packInputs) {
      return;
    }

    packInputs.forEach((input) => {
      const label =
        document.querySelector(
          `label[for="${CSS.escape(input.id)}"]`
        ) || input.closest("label");

      if (!label) {
        return;
      }

      const unavailable =
        input.disabled ||
        label.classList.contains("is-disabled");

      label.classList.toggle(
        "smart-pack-hidden",
        unavailable
      );

      label.setAttribute(
        "aria-hidden",
        unavailable ? "true" : "false"
      );
    });
  }

  function updateColourCount(picker) {
    if (
      !picker.hasAttribute(
        "data-smart-size-features"
      )
    ) {
      return;
    }

    const output = picker.querySelector(
      "[data-smart-colour-count]"
    );

    if (!output) {
      return;
    }

    const data = readVariantData(picker);
    const selectedValues =
      getSelectedOptionValueIds(picker);
    const selectedSizeId = selectedValues[0];

    if (
      !data?.variants?.length ||
      !selectedSizeId
    ) {
      output.textContent = "";
      return;
    }

    const colours = new Set(
      data.variants
        .filter(
          (variant) =>
            variant.available &&
            String(variant.optionValueIds[0]) ===
              String(selectedSizeId) &&
            variant.optionValueIds[
              COLOUR_OPTION_INDEX
            ] != null
        )
        .map((variant) =>
          String(
            variant.optionValueIds[
              COLOUR_OPTION_INDEX
            ]
          )
        )
    );

    const count = colours.size;

    output.textContent =
      count > 0
        ? `${count} ${
            count === 1 ? "colour" : "colours"
          } available in this size`
        : "";
  }

  function findSizeWithMostColours(variants) {
    const sizeColourMap = new Map();
    const sizeOrder = [];

    variants
      .filter((variant) => variant.available)
      .forEach((variant) => {
        const sizeId =
          variant.optionValueIds?.[0];
        const colourId =
          variant.optionValueIds?.[1];

        if (
          sizeId == null ||
          colourId == null
        ) {
          return;
        }

        const sizeKey = String(sizeId);
        const colourKey = String(colourId);

        if (!sizeColourMap.has(sizeKey)) {
          sizeColourMap.set(
            sizeKey,
            new Set()
          );
          sizeOrder.push(sizeKey);
        }

        sizeColourMap
          .get(sizeKey)
          .add(colourKey);
      });

    let bestSizeId = null;
    let highestColourCount = 0;

    sizeOrder.forEach((sizeId) => {
      const colourCount =
        sizeColourMap.get(sizeId)?.size || 0;

      if (
        colourCount >
        highestColourCount
      ) {
        highestColourCount = colourCount;
        bestSizeId = sizeId;
      }
    });

    return {
      sizeId: bestSizeId,
      colourCount: highestColourCount
    };
  }

  function findBestVariantForSize(
    variants,
    targetSizeId,
    currentValues
  ) {
    const candidates = variants.filter(
      (variant) =>
        variant.available &&
        String(
          variant.optionValueIds?.[0]
        ) === String(targetSizeId)
    );

    if (!candidates.length) {
      return null;
    }

    return (
      candidates.find(
        (variant) =>
          String(
            variant.optionValueIds?.[1]
          ) === String(currentValues[1]) &&
          String(
            variant.optionValueIds?.[2]
          ) === String(currentValues[2])
      ) ||
      candidates.find(
        (variant) =>
          String(
            variant.optionValueIds?.[1]
          ) === String(currentValues[1])
      ) ||
      candidates.find(
        (variant) =>
          String(
            variant.optionValueIds?.[2]
          ) === String(currentValues[2])
      ) ||
      candidates[0]
    );
  }

  function updateWidestRangeBadge(
    picker,
    widestSizeId
  ) {
    picker
      .querySelectorAll(
        "[data-smart-size-option]"
      )
      .forEach((sizeOption) => {
        const badge =
          sizeOption.querySelector(
            "[data-smart-widest-range-badge]"
          );

        if (!badge) {
          return;
        }

        const isWidest =
          String(
            sizeOption.dataset
              .smartSizeOption
          ) === String(widestSizeId);

        badge.hidden = !isWidest;

        sizeOption.classList.toggle(
          "smart-size-has-widest-range",
          isWidest
        );
      });
  }

  async function applyDefaultSize(picker) {
  /* Don't automatically change the customer's size on mobile. */
  if (isMobileVariantPicker()) {
    return;
  }

  if (
    !picker.hasAttribute(
        "data-smart-size-features"
      ) ||
      !picker.hasAttribute("update-url")
    ) {
      return;
    }

    const productKey =
      `${window.location.pathname}-` +
      picker.getAttribute("handle");

    if (
      processedProducts.has(productKey)
    ) {
      return;
    }

    const data = readVariantData(picker);

    if (!data?.variants?.length) {
      return;
    }

    if (
      typeof picker.selectCombination !==
      "function"
    ) {
      window.setTimeout(() => {
        applyDefaultSize(picker);
      }, 200);

      return;
    }

    const currentValues =
      getSelectedOptionValueIds(picker);

    if (currentValues.length < 2) {
      window.setTimeout(() => {
        applyDefaultSize(picker);
      }, 200);

      return;
    }

    const widestRange =
      findSizeWithMostColours(
        data.variants
      );

    if (!widestRange.sizeId) {
      return;
    }

    updateWidestRangeBadge(
      picker,
      widestRange.sizeId
    );

    processedProducts.add(productKey);

    if (
      String(currentValues[0]) ===
      String(widestRange.sizeId)
    ) {
      return;
    }

    const bestVariant =
      findBestVariantForSize(
        data.variants,
        widestRange.sizeId,
        currentValues
      );

    if (!bestVariant) {
      processedProducts.delete(productKey);
      return;
    }

    markVariantAsSelected(
      picker,
      bestVariant.optionValueIds
    );

    try {
      await picker.selectCombination({
        optionValues:
          bestVariant.optionValueIds.map(
            String
          ),
        productChange: false
      });
    } catch (error) {
      processedProducts.delete(productKey);

      console.error(
        "Paragon Smart Variants could not apply the default size.",
        error
      );
    }
  }

  function initialisePicker(picker) {
    filterPackSizes(picker);
    updateColourCount(picker);

    if (
      picker.hasAttribute(
        "data-smart-size-features"
      )
    ) {
      const data = readVariantData(picker);

      if (data?.variants?.length) {
        const widestRange =
          findSizeWithMostColours(
            data.variants
          );

        if (widestRange.sizeId) {
          updateWidestRangeBadge(
            picker,
            widestRange.sizeId
          );
        }
      }
    }
  }

  function initialiseAll(root = document) {
    if (
      root.matches?.("variant-picker")
    ) {
      initialisePicker(root);
    }

    root
      .querySelectorAll?.("variant-picker")
      .forEach(initialisePicker);
  }

  document.addEventListener(
    "change",
    handleVariantChange,
    true
  );

  document.addEventListener(
    "DOMContentLoaded",
    () => {
      window.setTimeout(() => {
        initialiseAll();

        document
          .querySelectorAll(
            "variant-picker[update-url][data-smart-size-features]"
          )
          .forEach(applyDefaultSize);
      }, 300);
    }
  );

  document.addEventListener(
    "shopify:section:load",
    (event) => {
      window.setTimeout(() => {
        initialiseAll(event.target);

        event.target
          .querySelectorAll?.(
            "variant-picker[update-url][data-smart-size-features]"
          )
          .forEach(applyDefaultSize);
      }, 300);
    }
  );

  const observer = new MutationObserver(
    (mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach(
          (node) => {
            if (
              !(
                node instanceof
                HTMLElement
              )
            ) {
              return;
            }

            initialiseAll(node);
          }
        );
      });
    }
  );

  observer.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );
})();